import type { ModularBlockConfig } from '../../../frontend/types';
import CmsSalesforceForm from './CmsSalesforceForm.vue';
import SalesforceForm from './SalesforceForm.vue';
import { blockSalesforceFormsFields } from './groq';

/** Shared registry entry — apps compose into their own `modularBlocksConfig`. */
export const salesforceFormBlockConfig = {
  name: 'inner-block-salesforce-form',
  component: CmsSalesforceForm,
  innerComponent: SalesforceForm,
  fields: blockSalesforceFormsFields,
} satisfies ModularBlockConfig;
